/**
 * frontend/src/components/common/ScrollToTop.js
 * 
 * Utility component that ensures the window scrolls to the top whenever the route changes.
 * This is particularly important for single-page applications (SPA) using React Router.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
